import React from 'react';
import { Container } from 'reactstrap';
import MediaLQDTU from '../Media/MediaLQDTU';
import '../Homepage/Research/style.css'; 
import { useIntl } from 'react-intl';

export default function HomepageMedia() {
    const intl = useIntl();

    return (
        <Container className="wp-research" style={{ paddingBottom: '0' }}>
            <h2 className="research-title" style={{ marginTop: '2rem', marginBottom: '2rem' }}>
                {intl.formatMessage({ id: 'Media' })}
            </h2>
            <MediaLQDTU />
        </Container>
    );
}
